import classNames from 'classnames';
import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { AtlFormCheckboxProps } from './form.props';
import { Sizes, enumAttributeConverter, SizesValuesMap } from '../enum-types';
import { AtlFormChangeEvent } from './form.events';
import { getGlobalStyleSheets } from '../../global-styles';

import * as TagNames from './form.tagnames';

@customElement(TagNames.FormCheckBox)
export class AtlFormCheckbox
   extends LitElement
   implements AtlFormCheckboxProps
{
   declare inputId: string;
   declare size?: Sizes;
   declare disabled?: boolean;
   declare checked: boolean;

   static properties = {
      inputId: { type: String },
      size: {
         type: String,
         convertor: enumAttributeConverter(Sizes, Sizes.Medium),
      },
      disabled: { type: Boolean },
      checked: { type: Boolean, state: true },
   };

   static styles = [...getGlobalStyleSheets()];

   render() {
      return html`
         <div class="form-check">
            <input
               id=${this.inputId}
               class=${classNames(
                  'form-check-input',
                  SizesValuesMap[this.size ?? Sizes.Medium]
               )}
               type="checkbox"
               .checked=${this.checked}
               ?disabled=${this.disabled}
               @click=${this._handleChange}
            />
         </div>
      `;
   }

   private _handleChange = (event: Event) => {
      const newValue = (event.target as HTMLInputElement)?.checked ?? false;
      this.checked = newValue;
      this.dispatchEvent(new AtlFormChangeEvent(newValue.toString()));
   };
}
